import { observer } from "mobx-react-lite";
import {
  FloatingArrow,
  FloatingPortal,
  arrow,
  autoUpdate,
  offset,
  useFloating,
} from "@floating-ui/react";
import type { ReactNode } from "react";
import { useEffect, useRef } from "react";
import { Html } from "@react-three/drei";

export const Mouse = observer(function Tooltip(props: {
  children: ReactNode;
  clientX: number;
  clientY: number;
}) {
  const arrowRef = useRef<SVGSVGElement>(null);
  const { refs, floatingStyles, update, context } = useFloating({
    strategy: "fixed",
    placement: "top",
    transform: false,
    whileElementsMounted: autoUpdate,
    middleware: [arrow({ element: arrowRef, padding: 0 }), offset(8)],
  });
  useEffect(() => {
    window.addEventListener("mousemove", update);
    return () => window.removeEventListener("mousemove", update);
  }, [update]);

  const mounted = floatingStyles.left !== 0 && floatingStyles.top !== 0;

  return (
    <Html>
      <FloatingPortal>
        <div
          ref={refs.setReference}
          style={{
            position: "fixed",
            top: props.clientY,
            left: props.clientX,
          }}
        />
        <div
          ref={refs.setFloating}
          style={{ ...floatingStyles, opacity: mounted ? 1 : 0 }}
          className="pointer-events-none"
        >
          {props.children}
          <FloatingArrow ref={arrowRef} context={context} />
        </div>
      </FloatingPortal>
    </Html>
  );
});
